import React from 'react';
import { NavLink } from 'react-router-dom';

export default (props) => (
	<NavLink {...props} onClick={() => window.scrollTo(0, 0)}>{props.children}</NavLink>
);


// WEBPACK FOOTER //
// ./src/components/NavLinkScrollTop/index.js